const cleanPercentage = (percentage) => {
  const tooLow = !Number.isFinite(+percentage) || percentage < 0;
  const tooHigh = percentage > 100;
  return tooLow ? 0 : tooHigh ? 100 : +percentage;
};

const Circle = ({ color, pct, size }) => {
  const r = (7 * size) / 18;
  const circ = 2 * Math.PI * r;
  const strokePct = ((100 - pct) * circ) / 100;
  return (
    <circle
      r={r}
      cx={size / 2}
      cy={size / 2}
      fill='transparent'
      stroke={strokePct !== circ ? color : ''} // remove color as 0% sets full circumference
      strokeWidth={`${(2 * size) / 50}px`}
      strokeDasharray={circ}
      strokeDashoffset={pct ? strokePct : 0}
      strokeLinecap='round'
      className='transition-all duration-700 ease-in-out'
    ></circle>
  );
};

const Text = ({ text, size }) => {
  return (
    <text
      x='50%'
      y='50%'
      dominantBaseline='central'
      textAnchor='middle'
      fontSize={`${(2 * size) / 25}px`}
      fill='white'
    >
      {text}
    </text>
  );
};

const Pie = ({ percentage, color, text, size }) => {
  const pct = cleanPercentage(percentage);
  return (
    <svg
      width={size}
      height={size}
    >
      <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
        <Circle
          color='#262626'
          size={size}
        />
        <Circle
          color={color}
          pct={pct}
          size={size}
        />
      </g>
      <Text
        text={text}
        size={size}
      />
    </svg>
  );
};

const RingProgress = ({ percentage, color, text, size, title, icon }) => {
  return (
    <div className='flex flex-col items-center justify-center'>
      <Pie
        percentage={percentage}
        color={color}
        text={text}
        size={size}
      />
      {(title || icon) && (
        <div className='flex items-center justify-center gap-1 text-white'>
          {title && <h2 className='text-xs whitespace-nowrap'>{title}</h2>}
          {icon}
        </div>
      )}
    </div>
  );
};

export default RingProgress;
